import React, { useState, useEffect } from "react";
import moment from "moment";
import { Image } from "react-bootstrap";
import { Modal } from "@material-ui/core";
import Grow from "@material-ui/core/Grow";
import closeIcon from "./../../assets/close.svg";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import BookingCalendar from "./BookingCalendar";
import PatientSearchAndSelectContainer from "./PatientSearchAndSelectContainer";
import ReviewAndShare from "./ReviewAndShare";
import Steps from "./Steps";
import "./styles.scss";
import useDisableHelp from "../../Hooks/useDisableHelp";
import { doctorProfileFiles } from "../../Util/API Calls/APIList";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import FutureAppointmentsView from "./FutureAppointmentsView";
import ResourceSelectionView from "./ResourceSelectionView";
import { getDoctorList } from "./APIHandler";
import {
  BLOCK_RESOURCE_SLOTS,
  BOOK_DOCTOR_APPOINTMENT,
  BOOK_RESOURCE_APPOINTMENT,
  GET_DOCTOR_LIST,
  GET_ORDER_ID,
  GET_RESOURCE_LIST_FOR_BOOKING,
  GET_RESOURCE_PROCEDURE_LIST,
  UNBLOCK_RESOURCE_SLOTS,
} from "./APIHandler/apiConstants";
import {
  BOOKING_TYPE,
  CHECK_HAS_RESOURCE_ACCESS,
  SLOT_STATUS,
} from "./Constants";
import C2CMiddlePopup from "../common/Popups/C2CMiddlePopup";
import { USER_ROLE } from "../../Util/constants";
import warningImg from "../../assets/cancelled.svg";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import swal from "sweetalert";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";
import backArrow from "../../assets/back_arrow_gray.svg";

function PhysicalConsultationModal(props) {
  const {
    doctorData,
    existingOrderId,
    addBooking,
    appointmentData,
    paymentMethod,
    handleSetAppointmentType,
    setProceedEnable,
    abhaPatientDetails,
    isAddNewAbhaPatient,
    existingPatientDetails,
    isAbhaTokenBooking,
    dashboardSelectedDate,
    allowCalendarChange,
    followUpBooking,
    bookingFromFollowUpDashboard,
    quoteProcedureList,
    isLeadBooking,
  } = props;
  const appointmentType = props.appointmentType;
  const [modalHeader, setModalHeader] = useState("");
  const [apiSelectedConsultation, setApiConsultationTypeValue] = useState({}); // sid: 0, id: 0, value: 0, label: 'Regular'
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [selectedSlotObj, setSelectedSlotObj] = useState({});

  const [state, setState] = useState(props.step);
  const [appointmentDetails, setAppointmentDetails] = useState({}); // Not sure if required, used in booking confirmation step 1
  const [patientAccountId, setPatientAccountId] = useState("");
  const [selectedBookingType, setSelectedBookingType] = useState("Clinic");
  const [showAbhaConfirmationPopup, setShowAbhaConfirmationPopup] =
    useState(false);
  const resource = true;
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const [allotedPremiumSlot, setAllotedPremiumSlot] = useState({
    startTime: "",
    endTime: "",
  });
  const [calenderDate, setCalenderDate] = useState(new Date());
  const [showPremiumSlotSelection, setShowPremiumSlotSelection] =
    useState(false);

  const [clinicSelection, setClinicSelection] = useState(false);
  // Required for Legacy component
  const patient = {
    patient_id: false,
    patient_name: "",
    doctor_id: "",
  };

  const doctor = {
    doctor_id: doctorData?.doctor_id ? doctorData?.doctor_id : userId,
    doctor_slug: props.doctor_slug,
  };
  const [patientDetails, setPatientDetails] = useState({
    mobileNumber: "",
    patientName: "",
    email: "",
    dob: "",
    sex: "",
    address: "",
    pincode: "",
    state: "",
    note: "",
    patient_id: "",
    appointment_id: "",
  }); // New patient details returned by form
  useDisableHelp();

  const [appointIDDetails, setAppointmentIDDetails] = useState({});
  const [followUpVal, setFollowUp] = useState(false);
  const [resourceList, setResourceList] = useState([]);
  const [procedureList, setProcedureList] = useState([]);
  const [selectedResource, setSelectedResource] = useState({});
  const [selectedProcedureList, setSelectedProcedureList] = useState([]);
  const [selectedResourceProcedure, setSelectedResourceProcedure] = useState(
    {}
  );
  const [orderId, setOrderId] = useState("");
  const [hasResourceAccess, setHasResourceAccess] = useState(false);
  const [searchProcedure, setSearchProcedure] = useState("");
  const [procedureListSearch, setProcedureListSearch] = useState([]);
  const [openCancelPopup, setOpenCancelPopup] = useState(false);
  const [openBookingModal, setOpenBookingModal] = useState(true);
  const [procedureAppointmentId, setProcedureAppointmentId] = useState("");
  const [dateToResetResource, setDateToResetResource] = useState(
    moment().format("DD-MM-YYYY")
  );
  const [disableSaveBtn, setDisableSaveBtn] = useState(false);
  const [retainedSlot, setRetainedSlot] = useState("");
  const [retainedSlotObj, setRetainedSlotObj] = useState({});
  const [retainedDate, setRetainedDate] = useState("");
  const [patientFormDetails, setPatientFormDetails] = useState({
    patient_no: "",
  });
  const [showAllotedPremiumSlot, setShowAllotedPremiumSlot] = useState(false);
  const [retainFileState, setRetainFileState] = useState({
    updateState: false,
    filesState: [],
  });

  const modalBodyClassName =
    (hasResourceAccess || addBooking) && state === 1
      ? "pc_modal_body_sec"
      : "pc_modal_body pc_scroll";

  const containerClassName =
    (hasResourceAccess || addBooking) && state === 1
      ? "book-appointments-container-wrapper-sec"
      : "book-appointments-container-wrapper";

  useEffect(() => {
    if (clinicId) {
      setHasResourceAccess(
        CHECK_HAS_RESOURCE_ACCESS(
          userType,
          doctorRole,
          (doctorData?.is_resource?.toLowerCase() == "true" ||
            followUpBooking) &&
            !isLeadBooking
        )
      );
    }
  }, []);

  useEffect(() => {
    if (
      dashboardSelectedDate &&
      moment(dashboardSelectedDate)?.isSameOrAfter(
        moment().format("YYYY-MM-DD")
      )
    ) {
      setCalenderDate(new Date(dashboardSelectedDate));
    } else {
      setCalenderDate(new Date());
    }
  }, [dashboardSelectedDate]);

  useEffect(() => {
    if (hasResourceAccess) {
      if (!existingOrderId) {
        if (!followUpBooking) {
          if (
            doctorRole !== USER_ROLE?.RESOURCE_CONSULTANT &&
            !quoteProcedureList?.doctorId
          ) {
            getResourceListAPICall();
          } else {
            if (!quoteProcedureList?.doctorId) {
              let resourceObj = {
                label: localStorage.getItem(LOCALSTORAGEKEY.FULL_NAME),
                value: userId,
                doctor_id: userId,
                common_procedure: doctorData?.common_procedure,
              };
              setSelectedResource({ ...resourceObj });
              setResourceList([resourceObj]);
            }
          }
        }
        //this condition added for editing appointment from online pending logs

        getOrderIdAPICall();
      }
    } else if (isAbhaTokenBooking || isLeadBooking) {
      getOrderIdAPICall();
    }
  }, [hasResourceAccess]);

  useEffect(() => {
    if (selectedResource?.doctor_id && !isLeadBooking && !followUpBooking) {
      getResourceProcedureAPICall();
    }
  }, [selectedResource]);

  useEffect(() => {
    let list = procedureListSearch?.filter((data) => {
      return data?.procedure_name
        ?.toLowerCase()
        ?.includes(searchProcedure?.toLowerCase());
    });
    setProcedureList(list);
  }, [searchProcedure]);

  useEffect(() => {
    if (dateToResetResource && hasResourceAccess) {
      handleClearResource();
    }
  }, [dateToResetResource]);

  useEffect(() => {
    if (!quoteProcedureList?.doctorId) {
      if (addBooking) {
        setSelectedResource({});
        setResourceList([]);
        setProcedureList([]);
        setProcedureListSearch([]);
        setSearchProcedure("");
        setSelectedProcedureList([]);
        setSelectedResourceProcedure({});
        if (selectedBookingType === "Laboratory") {
          getResourceListAPICall();
        } else {
          getDoctorListAPICall();
        }
      }
    }
  }, [selectedBookingType]);

  useEffect(() => {
    setAllotedPremiumSlot({
      startTime: "",
      endTime: "",
      slot_id: "",
    });
  }, [apiSelectedConsultation, selectedDate]);

  useEffect(() => {
    if (quoteProcedureList?.doctorId) {
      if (quoteProcedureList?.doctorType == 0) {
        getDoctorListAPICall(quoteProcedureList);
      } else {
        let bookingType = { label: "Laboratory", value: "Laboratory" };
        setSelectedBookingType(bookingType?.value);
        getResourceListAPICall(
          quoteProcedureList,
          bookingType?.value,
          quoteProcedureList?.doctorIds
        );
      }
    }
  }, [quoteProcedureList]);

  // API call
  const getResourceListAPICall = (
    quoteProcedureList,
    quoteBookingType,
    quoteDoctorIds
  ) => {
    let requestPayload = {
      clinic_id: clinicId,
      "authorizer-principal-id": {
        user_id: userId,
      },
    };
    let api = GET_RESOURCE_LIST_FOR_BOOKING;
    const resourceListResponse = c2cPostApiHandler(api, requestPayload);
    resourceListResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        if (res?.data?.doctor_list?.length > 0) {
          let list = res?.data?.doctor_list;
          list.forEach((data) => {
            data["label"] = data?.doctor_name;
            data["value"] = data?.doctor_id;
            data["common_procedure"] =
              data?.common_procedure?.toLowerCase() === "true";
          });
          let selectResource = list.filter(
            (data) => data?.doctor_id === doctorData?.doctor_id
          );
          setResourceList(list);
          if (quoteProcedureList?.doctorId) {
            let selectedDoctor = list.filter(
              (data) => data?.doctor_id === quoteProcedureList?.doctorId
            );
            if (selectedDoctor?.length > 0) {
              handleResource(
                selectedDoctor[0],
                quoteProcedureList?.procedureList,
                quoteBookingType,
                quoteDoctorIds
              );
            }
          } else {
            // added in else because sometime set to {} when quote data is availble
            setSelectedResource(
              selectResource?.length > 0 ? selectResource[0] : {}
            );
          }
        } else {
          setResourceList([]);
        }
      } else {
        setResourceList([]);
      }
    });
  };

  const getResourceProcedureAPICall = (
    doctorId,
    procedureList,
    quoteBookingType,
    quoteDoctorIds
  ) => {
    let api = GET_RESOURCE_PROCEDURE_LIST;
    let payload = {
      clinic_id: clinicId,
      doctor_id: doctorId ? doctorId : selectedResource?.doctor_id,
      doctor_ids: quoteDoctorIds,
    };
    let tempBookingType = quoteBookingType
      ? quoteBookingType
      : selectedBookingType;
    const procedureListResponse = c2cPostApiHandler(api, payload);
    procedureListResponse.then(([res, err]) => {
      let defaultOnlineProcedure = [
        {
          id: 0,
          procedure_name: "Tele-Consult Regular",
          consultation_type: 0,
        },
        {
          id: 1,
          procedure_name: "Tele-Consult Follow-up",
          consultation_type: 1,
        },
      ];
      let defaultProcedure = [
        ...(isLeadBooking || followUpBooking ? defaultOnlineProcedure : []),
        {
          id: 5,
          procedure_name: "In-Clinic Regular",
          consultation_type: 5,
        },
        {
          id: 6,
          procedure_name: "In-Clinic Follow-up",
          consultation_type: 6,
        },
      ];
      if (!err && res?.data?.statusCode === 200) {
        if (res?.data?.procedure_details?.length > 0) {
          let procedureFromAPI = res?.data?.procedure_details;

          let templist =
            addBooking && tempBookingType === BOOKING_TYPE.CLINIC
              ? [...defaultProcedure, ...procedureFromAPI]
              : [...procedureFromAPI];
          let list = formatProcedureList(templist, doctorId);
          setProcedureList(list);
          setProcedureListSearch(list);
          selectProcedureFromQuote(
            procedureList,
            list,
            quoteBookingType === "Clinic" ? 0 : quoteProcedureList?.doctorType,
            res?.data?.quote_doctor_list
          );
        } else {
          if (addBooking && tempBookingType === BOOKING_TYPE.CLINIC) {
            let list = formatProcedureList(defaultProcedure, doctorId);
            setProcedureList(list);
            setProcedureListSearch(list);
            selectProcedureFromQuote(
              procedureList,
              list,
              quoteBookingType === "Clinic"
                ? 0
                : quoteProcedureList?.doctorType,
              res?.data?.quote_doctor_list
            );
          } else {
            setProcedureList([]);
            setProcedureListSearch([]);
          }
        }
      } else {
        if (addBooking && tempBookingType === BOOKING_TYPE.CLINIC) {
          let list = formatProcedureList(defaultProcedure, doctorId);
          setProcedureList(list);
          setProcedureListSearch(list);
          selectProcedureFromQuote(
            procedureList,
            list,
            quoteBookingType === "Clinic" ? 0 : quoteProcedureList?.doctorType,
            res?.data?.quote_doctor_list
          );
        } else {
          setProcedureList([]);
          setProcedureListSearch([]);
        }
      }
    });
  };

  const formatProcedureList = (list, doctorId, quoteBookingType) => {
    let tempBookingType = quoteBookingType
      ? quoteBookingType
      : selectedBookingType;
    list.forEach((data) => {
      if (addBooking && tempBookingType === BOOKING_TYPE.CLINIC) {
        data["selected"] =
          selectedProcedureList?.length > 0
            ? selectedProcedureList.filter(
                (procedure) =>
                  procedure?.id === data?.id &&
                  (doctorId ? doctorId : selectedResource?.doctor_id) ===
                    selectedResourceProcedure?.doctor_id
              )?.length > 0
              ? true
              : false
            : false;
      } else {
        data["selected"] =
          selectedProcedureList?.length > 0
            ? selectedProcedureList.filter(
                (procedure) => procedure?.id === data?.id
              )?.length > 0
              ? true
              : false
            : false;
      }
      data["appointment_slot_id"] = "";
      data["appointment_date"] = "";
      data["start_time"] = "";
      data["end_time"] = "";
      data["status"] = "";
    });
    return list;
  };

  const getOrderIdAPICall = () => {
    let payload = {
      "authorizer-principal-id": {
        user_type: "1",
        user_id: userType === "staff" ? staffId : userId,
      },
    };
    const orderIdResponse = c2cPostApiHandler(GET_ORDER_ID, payload);
    orderIdResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        setOrderId(res?.data?.order_id);
      }
    });
  };

  const unblockSlotsAPICall = (slotArr) => {
    let payload = {
      slots: slotArr,
      user_id: userId,
      user_type: userType === "staff" ? "4" : "1",
      user_agent: "Web",
      clinic_id: clinicId,
      order_id:
        addBooking && !followUpBooking && !isAbhaTokenBooking && !isLeadBooking
          ? existingOrderId
          : orderId,
    };
    let api = UNBLOCK_RESOURCE_SLOTS;
    const unblockSlotsResponse = c2cPostApiHandler(api, payload);
    unblockSlotsResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        C2CConsole.log("slots unblocked");
      }
    });
  };

  const getDoctorListAPICall = (quoteProcedureList) => {
    let params = { clinic_id: clinicId, account_type: 0 };
    const clinicDoctorList = getDoctorList(GET_DOCTOR_LIST, params);
    clinicDoctorList.then(([res, err]) => {
      setResourceList(res);
      if (quoteProcedureList?.doctorId) {
        let selectedDoctor = res.filter(
          (data) => data?.doctor_id === quoteProcedureList?.doctorId
        );
        if (selectedDoctor?.length > 0) {
          handleResource(
            selectedDoctor[0],
            quoteProcedureList?.procedureList,
            "Clinic"
          );
        }
      }
    });
  };

  const selectProcedureFromQuote = (
    quoteProcedure,
    apiProcedure,
    quoteDoctorType,
    commonProcedureList
  ) => {
    if (quoteProcedure?.length > 0) {
      if (quoteDoctorType === 0) {
        let procedureId =
          quoteProcedure[0]?.consultation_type == "4"
            ? quoteProcedure[0]?.procedure_id
            : quoteProcedure[0]?.consultation_type;
        let selectedProcedure = apiProcedure?.filter(
          (data) => data?.id == procedureId
        );
        if (selectedProcedure?.length > 0) {
          // handleProcedure(selectedProcedure[0], apiProcedure);
          let procedure = quoteProcedure[0];
          apiProcedure.forEach((data) => {
            if (data?.id == procedureId) {
              data.selected = true;
              data["active"] = data.selected;
            }
          });
          setProcedureList([...apiProcedure]);
          quoteProcedure.forEach((data) => {
            data["selected"] = true;
            data["appointment_slot_id"] = "";
            data["appointment_date"] = "";
            data["start_time"] = "";
            data["end_time"] = "";
            data["status"] = "";
            data["consultation_type"] = data?.consultation_type
              ? Number(data?.consultation_type)
              : null;
            data["id"] =
              data?.consultation_type != "4"
                ? data?.consultation_type
                : data?.procedure_id;
            data["active"] = procedure?.doctor_id === data?.doctor_id;
            data["custom_slot"] = false;
          });
          setSelectedProcedureList([...quoteProcedure]);
          setSelectedResourceProcedure({
            doctor_id: procedure?.doctor_id,
            id: procedure?.id,
            common_procedure: false,
            callAPI: true,
            consultation_type: procedure?.consultation_type,
          });
        }
      } else {
        let procedureIds = [];
        quoteProcedure.forEach((qdata) => {
          procedureIds.push(qdata?.procedure_id);
        });
        apiProcedure.forEach((data) => {
          data["selected"] = procedureIds.includes(data?.id);
        });
        setProcedureList([...apiProcedure]);
        let apiProcedureData = apiProcedure?.length > 0 ? apiProcedure[0] : "";
        let procedure = quoteProcedure[0];
        procedure["active"] = true;
        quoteProcedure.forEach((data) => {
          data["selected"] = true;
          data["appointment_slot_id"] = "";
          data["appointment_date"] = "";
          data["start_time"] = "";
          data["end_time"] = "";
          data["status"] = "";
          data["consultation_type"] = data?.consultation_type
            ? Number(data?.consultation_type)
            : null;
          data["id"] =
            data?.consultation_type != "4"
              ? data?.consultation_type
              : data?.procedure_id;
          let procedureIndex = commonProcedureList?.findIndex(
            (pdata) => pdata?.doctor_id === data?.doctor_id
          );

          let isCommonProcedure =
            procedureIndex > -1
              ? commonProcedureList[procedureIndex]
                  ?.has_common_schedule_procedures
              : false;
          data["active"] = isCommonProcedure
            ? apiProcedureData?.doctor_id === data?.doctor_id
            : data?.procedure_id === procedure?.procedure_id;
          data["common_procedure"] = isCommonProcedure;
          // apiProcedureData?.doctor_id === data?.doctor_id &&
          // apiProcedureData?.common_procedure;
          data["custom_slot"] = false;
        });
        setSelectedProcedureList([...quoteProcedure]);
        let selectedProcedureList = quoteProcedure;
        if (procedure?.common_procedure) {
          const commonProcedure =
            selectedProcedureList.find(
              (element) => element.selected && element.active
            ) ?? procedure;
          setSelectedResourceProcedure({
            doctor_id: commonProcedure?.doctor_id,
            id: commonProcedure?.id,
            common_procedure: procedure?.common_procedure,
            callAPI: true, //tempSelectedResourceProcedure?.length == 1 ? true : false,
          });
        } else {
          const activeProcedure =
            selectedProcedureList.find(
              (element) => element.selected && element.active
            ) ?? procedure;
          setSelectedResourceProcedure({
            doctor_id: activeProcedure?.doctor_id,
            id: activeProcedure?.id,
            common_procedure: activeProcedure?.common_procedure,
            callAPI: true,
          });
        }
        // handleProcedure(quoteProcedure[0], [...apiProcedure], quoteProcedure);
      }
    }
  };

  // Actions

  const handelProcedureAppointmentId = (appointmentId) => {
    setProcedureAppointmentId(appointmentId);
  };

  const handleResource = (
    onSelectedResource,
    procedureList,
    quoteBookingType,
    quoteDoctorIds
  ) => {
    if (addBooking && selectedBookingType === BOOKING_TYPE.CLINIC) {
      setProcedureListSearch([]);
      setSearchProcedure("");
      setSelectedProcedureList([]);
      setSelectedResourceProcedure({});
    }
    setSelectedResource(onSelectedResource);
    if (selectedResource?.doctor_id !== onSelectedResource?.doctor_id) {
      getResourceProcedureAPICall(
        onSelectedResource?.doctor_id,
        procedureList,
        quoteBookingType,
        quoteDoctorIds
      );
    }
  };

  const handleProcedure = (procedure, apiProcedureList) => {
    let tempProcedureList = apiProcedureList ? apiProcedureList : procedureList;
    let list = [...selectedProcedureList];
    if (!procedure.selected) {
      if (procedure.common_procedure && selectedProcedureList?.length > 0) {
        let filtered = tempProcedureList.filter(
          (obj) => obj.doctor_id === procedure.doctor_id
        );
        if (filtered?.length > 0) {
          procedure["alloted_custom_slot"] = filtered[0]?.custom_slot
            ? filtered[0]?.alloted_custom_slot
            : "";
          procedure["custom_slot"] = showPremiumSlotSelection;
        }
      } else {
        procedure["alloted_custom_slot"] = "";
        procedure["custom_slot"] = showPremiumSlotSelection;
      }
    } else {
      procedure["custom_slot"] = showPremiumSlotSelection;
    }
    setSelectedProcedureList(tempProcedureList);
    if (addBooking && selectedBookingType === "Clinic") {
      handleClinicProcedure(procedure, tempProcedureList);
      handleIsFollowUp(procedure);
    } else {
      let procedure_list = [...tempProcedureList];
      let index = procedure_list.findIndex(
        (data) => data?.id === procedure?.id
      );

      let filteredList = [];
      if (selectedProcedureList?.length > 0) {
        filteredList = selectedProcedureList.filter(
          (data) =>
            data?.doctor_id === procedure?.doctor_id &&
            data?.appointment_slot_id
        );
      } else {
        filteredList = [];
      }
      if (procedure?.common_procedure && filteredList?.length > 0) {
        procedure_list[index].selected = !procedure?.selected;
        procedure_list[index].status = filteredList[0]?.status;
        procedure_list[index].start_time = filteredList[0]?.start_time;
        procedure_list[index].end_time = filteredList[0]?.end_time;
        procedure_list[index].appointment_date =
          filteredList[0]?.appointment_date;
        procedure_list[index].appointment_slot_id =
          filteredList[0]?.appointment_slot_id;
        procedure_list[index].is_walkin = filteredList[0]?.is_walkin;
      } else {
        procedure_list[index].selected = !procedure?.selected;
        procedure_list[index].status = "";
        procedure_list[index].start_time = "";
        procedure_list[index].end_time = "";
        procedure_list[index].appointment_date = "";
        procedure_list[index].appointment_slot_id = "";
        procedure_list[index].is_walkin = false;
      }
      if (procedure_list[index].selected) {
        list.push(procedure_list[index]);
        list.forEach((data) => {
          if (procedure?.common_procedure) {
            if (data?.doctor_id === procedure?.doctor_id) {
              data["active"] = true;
            } else {
              data["active"] = false;
            }
          } else {
            data["active"] = data?.id === procedure?.id;
          }
        });
        setSelectedProcedureList(list);
      } else {
        let selectdIndex = selectedProcedureList.findIndex(
          (data) => data?.id === procedure?.id
        );
        selectedProcedureList.splice(selectdIndex, 1);
        let checkHasCommonProcedure = [];
        if (selectedProcedureList?.length > 0) {
          checkHasCommonProcedure = selectedProcedureList.filter(
            (data) => data?.doctor_id === procedure?.doctor_id
          );
        } else {
          checkHasCommonProcedure = [];
        }
        if (
          (procedure?.common_procedure &&
            checkHasCommonProcedure?.length == 0) ||
          !procedure?.common_procedure
        ) {
          if (
            procedure?.appointment_slot_id &&
            procedure?.status === SLOT_STATUS.SUCCESS
          ) {
            let slotArr = [procedure?.appointment_slot_id];
            unblockSlotsAPICall(slotArr);
          }
        }
        if (selectedProcedureList.length > 0) {
          let lastSelectedProcedure =
            selectedProcedureList[selectedProcedureList.length - 1];
          selectedProcedureList.forEach((data) => {
            data["active"] = data?.id === lastSelectedProcedure?.id;
          });
        }
        setSelectedProcedureList(selectedProcedureList);
      }
      setProcedureList(procedure_list);
      if (procedure?.common_procedure) {
        const commonProcedure =
          selectedProcedureList.find(
            (element) => element.selected && element.active
          ) ?? procedure;
        setSelectedResourceProcedure({
          doctor_id: commonProcedure?.doctor_id,
          id: commonProcedure?.id,
          common_procedure: procedure?.common_procedure,
          callAPI: true, //tempSelectedResourceProcedure?.length == 1 ? true : false,
        });
      } else {
        const activeProcedure =
          selectedProcedureList.find(
            (element) => element.selected && element.active
          ) ?? procedure;
        setSelectedResourceProcedure({
          doctor_id: activeProcedure?.doctor_id,
          id: activeProcedure?.id,
          common_procedure: activeProcedure?.common_procedure,
          callAPI: true,
        });
      }
    }
  };

  const handleSelectChip = (procedure) => {
    if (procedure?.common_procedure) {
      let tempSelectedResourceProcedure = selectedProcedureList?.filter(
        (data) => data?.doctor_id == procedure?.doctor_id
      );
      let selectedResourceProcedureIDs = [];
      tempSelectedResourceProcedure.forEach((procedureData) => {
        selectedResourceProcedureIDs.push(procedureData?.id);
      });
      setSelectedResourceProcedure({
        doctor_id: procedure?.doctor_id,
        id: selectedResourceProcedureIDs[0],
        callAPI: true,
        common_procedure: true,
      });
      selectedProcedureList.forEach((data) => {
        data.active = data?.doctor_id === procedure?.doctor_id;
      });
      setSelectedProcedureList(selectedProcedureList);
    } else {
      setSelectedResourceProcedure({
        doctor_id: procedure?.doctor_id,
        id: procedure?.id,
        common_procedure: false,
      });
      selectedProcedureList.forEach(
        (data) => (data.active = data?.id == procedure?.id)
      );
      setSelectedProcedureList(selectedProcedureList);
    }
  };

  const handleRemoveChip = (procedure) => {
    if (addBooking && selectedBookingType === "Clinic") {
      setSelectedResourceProcedure({});
      setSelectedProcedureList([]);
      let procedure_list = [...procedureList];
      let index = procedure_list.findIndex(
        (data) => data?.id === procedure?.id
      );
      if (index > -1) {
        procedure_list[index].selected = false;
      }
      setProcedureList(procedure_list);
    } else {
      let filteredProcedureList = selectedProcedureList.filter(
        (data) => data?.id !== procedure?.id
      );
      let procedure_list = [...procedureList];
      let index = procedure_list.findIndex(
        (data) => data?.id === procedure?.id
      );
      if (index > -1) {
        procedure_list[index].selected = false;
      }
      if (filteredProcedureList?.length > 0) {
        if (filteredProcedureList[0].common_procedure) {
          filteredProcedureList.forEach((data) => {
            data["active"] =
              data?.doctor_id === filteredProcedureList[0]?.doctor_id
                ? true
                : false;
          });
        } else {
          filteredProcedureList.map((data) => (data.active = false));
          filteredProcedureList[0].active = true;
        }
      }
      setSelectedProcedureList([...filteredProcedureList]);

      if (procedure?.common_procedure) {
        if (filteredProcedureList?.length > 0) {
          let doctorId = filteredProcedureList[0]?.doctor_id;
          let tempSelectedResourceProcedure = filteredProcedureList?.filter(
            (procedureData) => procedureData?.doctor_id === doctorId
          );
          let selectedResourceProcedureIDs = [];
          tempSelectedResourceProcedure.forEach((procedureData) => {
            selectedResourceProcedureIDs.push(procedureData?.id);
          });

          let checkHasCommonProcedure = filteredProcedureList.filter(
            (data) => data?.doctor_id === procedure?.doctor_id
          );
          if (checkHasCommonProcedure?.length === 0) {
            if (
              procedure?.appointment_slot_id &&
              procedure?.status === SLOT_STATUS.SUCCESS
            ) {
              let slotArr = [procedure?.appointment_slot_id];
              unblockSlotsAPICall(slotArr);
            }
            setSelectedResourceProcedure({
              doctor_id: filteredProcedureList[0]?.doctor_id,
              id: filteredProcedureList[0]?.id,
              common_procedure: false,
            });
          } else {
            setSelectedResourceProcedure({
              doctor_id: filteredProcedureList[0]?.doctor_id,
              id: selectedResourceProcedureIDs[0],
              callAPI: true,
              common_procedure: true,
            });
          }
        } else {
          setSelectedResourceProcedure({});
          if (
            procedure?.appointment_slot_id &&
            procedure?.status === SLOT_STATUS.SUCCESS
          ) {
            let slotArr = [procedure?.appointment_slot_id];
            unblockSlotsAPICall(slotArr);
          }
        }
      } else {
        setSelectedResourceProcedure(
          filteredProcedureList?.length > 0 ? filteredProcedureList[0] : {}
        );
        if (
          procedure?.appointment_slot_id &&
          procedure?.status === SLOT_STATUS.SUCCESS
        ) {
          let slotArr = [procedure?.appointment_slot_id];
          unblockSlotsAPICall(slotArr);
        }
      }
    }
  };

  const handleSelectResourceSlot = (slot, slotObj, date) => {
    if (addBooking && selectedBookingType === "Clinic") {
      let index = selectedProcedureList.findIndex(
        (data) => data?.id === selectedResourceProcedure?.id
      );
      selectedProcedureList[index].start_time = slotObj?.start_time;
      selectedProcedureList[index].end_time = slotObj?.end_time;
      selectedProcedureList[index].appointment_slot_id = slot;
      selectedProcedureList[index].appointment_date = moment(date._d).format(
        "YYYY-MM-DD"
      );
      selectedProcedureList[index].is_walkin = slotObj?.is_walkin;
      selectedProcedureList[index]["status"] = SLOT_STATUS.SUCCESS;

      setSelectedProcedureList([...selectedProcedureList]);
    } else {
      setDisableSaveBtn(true);
      if (selectedResourceProcedure?.common_procedure) {
        let filteredProcedureList = selectedProcedureList?.filter(
          (data) => data?.doctor_id === selectedResourceProcedure?.doctor_id
        );
        let payload = {};
        if (
          filteredProcedureList[0]?.appointment_slot_id &&
          filteredProcedureList[0]?.status === SLOT_STATUS.SUCCESS
        ) {
          let slotArr = [filteredProcedureList[0]?.appointment_slot_id];
          unblockSlotsAPICall(slotArr);
        }
        payload = {
          slot_id: slot,
          user_id: userId,
          user_type: userType === "staff" ? "4" : "1",
          user_agent: "Web",
          doctor_id: selectedResourceProcedure?.doctor_id,
          clinic_id: clinicId,
          order_id:
            addBooking &&
            !followUpBooking &&
            !isAbhaTokenBooking &&
            !isLeadBooking
              ? existingOrderId
              : orderId,
        };
        const blockedSlotResponse = c2cPostApiHandler(
          BLOCK_RESOURCE_SLOTS,
          payload
        );
        blockedSlotResponse.then(([res, err]) => {
          selectedProcedureList.forEach((list) => {
            if (list?.doctor_id === selectedResourceProcedure?.doctor_id) {
              list.start_time = slotObj?.start_time;
              list.end_time = slotObj?.end_time;
              list.appointment_slot_id = slot;
              list.appointment_date = moment(date._d).format("YYYY-MM-DD");
              list.is_walkin = slotObj?.is_walkin;
              if (!err && res?.data?.statusCode === 200) {
                list["status"] = SLOT_STATUS.SUCCESS;
              } else {
                list["status"] = SLOT_STATUS.FAILURE;
              }
            }
          });

          setSelectedProcedureList([...selectedProcedureList]);
          setDisableSaveBtn(false);
        });
      } else {
        let index = selectedProcedureList.findIndex(
          (data) => data?.id === selectedResourceProcedure?.id
        );
        let payload = {};
        if (
          selectedProcedureList[index]?.appointment_slot_id &&
          selectedProcedureList[index]?.status === SLOT_STATUS.SUCCESS
        ) {
          let slotArr = [selectedProcedureList[index]?.appointment_slot_id];
          unblockSlotsAPICall(slotArr);
        }
        payload = {
          slot_id: slot,
          user_id: userId,
          user_type: userType === "staff" ? "4" : "1",
          user_agent: "Web",
          doctor_id: selectedResourceProcedure?.doctor_id,
          clinic_id: clinicId,
          order_id:
            addBooking &&
            !followUpBooking &&
            !isAbhaTokenBooking &&
            !isLeadBooking
              ? existingOrderId
              : orderId,
        };
        const blockedSlotResponse = c2cPostApiHandler(
          BLOCK_RESOURCE_SLOTS,
          payload
        );
        blockedSlotResponse.then(([res, err]) => {
          selectedProcedureList[index].start_time = slotObj?.start_time;
          selectedProcedureList[index].end_time = slotObj?.end_time;
          selectedProcedureList[index].appointment_slot_id = slot;
          selectedProcedureList[index].appointment_date = moment(
            date._d
          ).format("YYYY-MM-DD");
          selectedProcedureList[index].is_walkin = slotObj?.is_walkin;
          if (!err && res?.data?.statusCode === 200) {
            selectedProcedureList[index]["status"] = SLOT_STATUS.SUCCESS;
          } else {
            selectedProcedureList[index]["status"] = SLOT_STATUS.FAILURE;
          }
          setSelectedProcedureList([...selectedProcedureList]);
          setDisableSaveBtn(false);
        });
      }
    }
  };

  const handleSearchProcedure = (value) => {
    setSearchProcedure(value);
  };

  const handleClearResource = () => {
    let slotsArr = [];
    if (selectedProcedureList?.length > 0) {
      selectedProcedureList.forEach((data) => {
        if (data?.appointment_slot_id) {
          slotsArr.push(data?.appointment_slot_id);
          data.appointment_slot_id = "";
          data.appointment_date = "";
          data.start_time = "";
          data.end_time = "";
          data.status = "";
        }
      });
      if (slotsArr?.length > 0) {
        unblockSlotsAPICall(slotsArr);
      }
    }
    setSelectedProcedureList(selectedProcedureList);
  };

  const handleConfirmClose = () => {
    unblockAllSlots();
    props.closeView();
    props?.callNextAppointmentWidget && props.callNextAppointmentWidget();
  };

  const handleDateToResetResource = (date) => {
    setDateToResetResource(date);
  };

  const handleAppointIDDEtails = (data) => {
    setAppointmentIDDetails(data);

    handleContinueClick();
  };

  const handleBookingType = (data) => {
    if (data?.value === BOOKING_TYPE.CLINIC) {
      unblockAllSlots();
      setClinicSelection(true);
    }
    setSelectedBookingType(data?.value);
    if (addBooking) {
      setSelectedResource({});
      setResourceList([]);
      setProcedureList([]);
      setProcedureListSearch([]);
      setSearchProcedure("");
      setSelectedProcedureList([]);
      setSelectedResourceProcedure({});
      if (data?.value === "Laboratory") {
        getResourceListAPICall({}, data?.value);
      } else {
        let obj = {};
        if (quoteProcedureList?.clinicDoctorId && !clinicSelection) {
          obj.doctorId = quoteProcedureList?.clinicDoctorId;
          obj.procedureList = quoteProcedureList?.clinicProcedureList;
          obj.doctorType = 0;
          obj.doctorIds = [];
        }

        getDoctorListAPICall(obj);
      }
    }
  };

  const handleReset = () => {
    setSelectedResource({});
    setResourceList([]);
    setProcedureList([]);
    setProcedureListSearch([]);
    setSearchProcedure("");
    setSelectedProcedureList([]);
    setSelectedResourceProcedure({});
  };

  const handleShowAbhaConfirmationContent = () => {
    setShowAbhaConfirmationPopup(true);
  };

  const handleCloseAbhaConfirmationContent = () => {
    setShowAbhaConfirmationPopup(false);
  };

  const handleClinicProcedure = (procedure, procedureList) => {
    let procedure_list = [...procedureList];
    procedure_list.forEach((data) => {
      data.status = "";
      data.start_time = "";
      data.end_time = "";
      data.appointment_date = "";
      data.appointment_slot_id = "";
      data.is_walkin = false;
      if (data?.id === procedure?.id) {
        data.selected = !data.selected;
        data["active"] = data.selected;
      } else {
        data.selected = false;
      }
    });
    let list = procedure_list.filter((ele) => ele.selected);
    setSelectedProcedureList(list);
    setProcedureList(procedure_list);
    setSelectedResourceProcedure({
      doctor_id: selectedResource?.doctor_id,
      id: procedure?.id,
      common_procedure: false,
      callAPI: true,
      consultation_type: procedure?.consultation_type,
    });
  };

  useEffect(() => {
    addNewPatient();
  }, [patientDetails]);
  useEffect(() => {
    switch (appointmentType) {
      case "in-clinic":
        setModalHeader("In-Clinic Consultation");
        break;
      case "online":
        setModalHeader("Online Consultation");
        break;
      default:
        break;
    }
  }, [appointmentType]);

  const handleIsFollowUp = (value) => {
    if (value.id == "1") {
      setFollowUp(true);
    } else {
      setFollowUp(false);
    }
  };

  const handlePremiumToggleSwitch = (e) => {
    if (hasResourceAccess || addBooking) {
      let list = [...selectedProcedureList];
      list.forEach((obj) => {
        if (obj.id === selectedResourceProcedure?.id) {
          obj["custom_slot"] = e.target.checked;
        }
      });
      if (selectedResourceProcedure?.common_procedure) {
        let list = [...selectedProcedureList];
        list.forEach((obj) => {
          if (obj.doctor_id === selectedResourceProcedure?.doctor_id) {
            obj["custom_slot"] = e.target.checked;
          }
        });
      }
      setSelectedProcedureList(list);
    } else {
      setShowPremiumSlotSelection(e.target.checked);
    }
  };

  const getViewState = (state) => {
    return (
      <>
        {state == 1 && (
          <Grow
            in={state == 1}
            style={{ transformOrigin: "0 0 0" }}
            timeout={700}
          >
            <BookingCalendar
              bookingFromFollowUpDashboard={bookingFromFollowUpDashboard}
              middleContent={middleContent}
              patient={patient}
              doctor={addBooking ? selectedResource : doctor}
              is_follow_up={false}
              disableSaveBtn={disableSaveBtn}
              retainedSlot={retainedSlot}
              retainedSlotObj={retainedSlotObj}
              setState={setState}
              setAppointmentDetails={setAppointmentDetails}
              appointmentDetails={appointmentDetails}
              selectedSlotCallback={handleSelectedSlotCallback}
              handleContinueClick={handleContinueClick}
              selectedSlot={selectedSlot}
              handleIsFollowUp={handleIsFollowUp}
              handleSlotToEMpty={handleSlotToEMpty}
              appointmentType={props.appointmentType}
              type="modal"
              selectedProcedureList={selectedProcedureList}
              selectedResourceProcedure={selectedResourceProcedure}
              apiSelectedConsultation={apiSelectedConsultation}
              addBooking={addBooking}
              allowCalendarChange={allowCalendarChange}
              selectedBookingType={selectedBookingType}
              handleSelectChip={handleSelectChip}
              handleRemoveChip={handleRemoveChip}
              handleSelectResourceSlot={handleSelectResourceSlot}
              hasResourceAccess={hasResourceAccess}
              handleClearResource={handleClearResource}
              handleDateToResetResource={handleDateToResetResource}
              state={state}
              booking_type={"doctor"}
              isAbhaTokenBooking={isAbhaTokenBooking}
              allotedPremiumSlot={allotedPremiumSlot}
              showAllotedPremiumSlot={showAllotedPremiumSlot}
              calenderDate={calenderDate}
              setCalenderDate={setCalenderDate}
              setAllotedPremiumSlot={setAllotedPremiumSlot}
              setShowAllotedPremiumSlot={setShowAllotedPremiumSlot}
              showPremiumSlotSelection={showPremiumSlotSelection}
              setShowPremiumSlotSelection={setShowPremiumSlotSelection}
              handlePremiumToggleSwitch={handlePremiumToggleSwitch}
              setSelectedResourceProcedure={setSelectedResourceProcedure}
              setSelectedProcedureList={setSelectedProcedureList}
              setApiConsultationTypeValue={setApiConsultationTypeValue}
              dashboardSelectedDate={
                retainedDate ? retainedDate : dashboardSelectedDate
              }
              isLeadBooking={isLeadBooking}
              followUpBooking={followUpBooking}
            />
          </Grow>
        )}
        <PatientSearchAndSelectContainer
          state={state}
          handelProcedureAppointmentId={handelProcedureAppointmentId}
          appointmentType={appointmentType}
          selectedDate={
            selectedDate || moment(calenderDate).format("YYYY-MM-DD")
          }
          selectedSlot={selectedSlot}
          selectedSlotObj={selectedSlotObj}
          patientDetails={patientFormDetails}
          setPatientDetails={setPatientFormDetails}
          handleContinueClick={handleContinueClick}
          handleAppointIDDEtails={handleAppointIDDEtails}
          followUpVal={followUpVal}
          doctorData={doctorData}
          setPatientAccountId={setPatientAccountId}
          orderId={orderId}
          selectedProcedureList={selectedProcedureList}
          hasResourceAccess={hasResourceAccess}
          abhaPatientDetails={abhaPatientDetails}
          isAddNewAbhaPatient={isAddNewAbhaPatient}
          existingPatientDetails={existingPatientDetails}
          addBooking={addBooking}
          selectedBookingType={selectedBookingType}
          showAbhaConfirmationPopup={showAbhaConfirmationPopup}
          handleCloseAbhaConfirmationContent={
            handleCloseAbhaConfirmationContent
          }
          selectedResource={selectedResource}
          isAbhaTokenBooking={isAbhaTokenBooking}
          allotedPremiumSlot={allotedPremiumSlot}
          showPremiumSlotSelection={showPremiumSlotSelection}
          setShowPremiumSlotSelection={setShowPremiumSlotSelection}
          selectedResourceProcedure={selectedResourceProcedure}
          apiSelectedConsultation={apiSelectedConsultation}
          isLeadBooking={isLeadBooking}
          appointmentData={appointmentData}
          retainFileState={retainFileState}
          handleFileState={handleFileState}
        />

        {state == 3 && (
          <Grow
            in={state == 3}
            style={{ transformOrigin: "0 0 0" }}
            timeout={700}
          >
            <div className="w-100">
              <ReviewAndShare
                procedureAppointmentId={procedureAppointmentId}
                selectedSlotObj={selectedSlotObj}
                appointmentType={
                  isLeadBooking || followUpBooking
                    ? selectedResourceProcedure?.consultation_type == 0 ||
                      selectedResourceProcedure?.consultation_type == 1
                      ? "online"
                      : appointmentType
                    : appointmentType
                }
                appointmentId={
                  props.appointmentId
                    ? props.appointmentId
                    : appointIDDetails.appointment_id
                }
                paymentMethod={paymentMethod}
                submitCallback={handleSubmitClick}
                isAddMode={props.isAddMode}
                hasResourceAccess={hasResourceAccess && !followUpBooking}
                orderId={
                  existingOrderId && !isAbhaTokenBooking
                    ? existingOrderId
                    : orderId
                }
                existingOrderId={existingOrderId}
                closeModel={closeModal}
                handleSetAppointmentType={handleSetAppointmentType}
                setProceedEnable={setProceedEnable}
                addBooking={addBooking}
                selectedBookingType={selectedBookingType}
                appointmentData={appointmentData}
              />
            </div>
          </Grow>
        )}
      </>
    );
  };

  const closeModal = (e, isProceedBtn = false) => {
    if (
      (state == 1 && hasResourceAccess && selectedProcedureList?.length > 0) ||
      (state == 1 &&
        addBooking &&
        selectedBookingType === "Laboratory" &&
        selectedProcedureList?.length > 0)
    ) {
      setOpenBookingModal(false);
      setOpenCancelPopup(true);
    } else {
      setSelectedBookingType("Clinic");
      props.closeView(isProceedBtn);
      props?.callNextAppointmentWidget && props.callNextAppointmentWidget();
    }
    handleReset();
  };

  const handleBackArrow = () => {
    setState(1);
  };

  function handleContinueClick() {
    if (addBooking && state === 1 && !isAbhaTokenBooking && !isLeadBooking) {
      addBookingAPICall();
    } else {
      switch (state) {
        case 1:
          setState(state + 1);
          setRetainedDate(new Date(selectedDate));
          setRetainedSlot(selectedSlot);
          setRetainedSlotObj({ ...selectedSlotObj });
          handleFileState({ ...retainFileState, updateState: true });
          if (isAbhaTokenBooking && !isAddNewAbhaPatient) {
            handleShowAbhaConfirmationContent();
          }
          break;
        case 2:
          setState(state + 1);
          break;
        default:
          break;
      }
    }
  }

  const handleProcedureList = () => {
    setProcedureList([]);
  };

  function handleSubmitClick(appointmentDetails) {
    setState(state + 1);
  }

  function handleSelectedSlotCallback(slot, date, slotObj) {
    setSelectedSlot(slot);
    setSelectedSlotObj(slotObj);
    setSelectedDate(moment(date.meta).format("YYYY-MM-DD"));
  }

  function handleSlotToEMpty() {
    setSelectedSlot("");
    setSelectedSlotObj({});
  }

  function addNewPatient() {
    afterLoginApiAxios
      .post(
        "doctor/inclinic-patient-add",
        {
          phone_no: patientDetails.mobileNumber,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data.statusCode == 200) {
          // Add patient id to the object
          let details = patientDetails;
          details.patient_id = response.data.patient_id;
          setPatientDetails(details);
          if (hasResourceAccess) {
            saveResourcePatientDetails(response.data.patient_id);
          } else {
            savePatientDetails(response.data.patient_id);
          }
        } else {
          C2CConsole.log("Error occurred");
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function savePatientDetails(patient_id) {
    const requestPayload = prepareSavePatientPayload(patient_id);
    const id = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
    if (localStorage.getItem("user_type") === "staff") {
      requestPayload.staff_id = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
    }
    if (id !== "" && id !== undefined && id !== null) {
      requestPayload["clinic_id"] = id;
    }

    requestPayload["is_walkin"] = selectedSlotObj.is_walkin;

    afterLoginApiAxios({
      method: "post",
      url:
        id !== "" && id !== undefined && id !== null
          ? "/clinic/book-physical-appointment-add-details"
          : "public/book-physical-appointment-add-details",

      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: requestPayload,
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          // Add appointment id to the object
          let details = patientDetails;
          details.appointment_id = response.data.appointment_id;
          setPatientDetails(details);
        } else {
          C2CConsole.log("Error occurred");
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function saveResourcePatientDetails(patient_id) {
    const requestPayload = prepareSavePatientPayload(patient_id);
    const id = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
    if (localStorage.getItem("user_type") === "staff") {
      requestPayload.staff_id = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
    }
    if (id !== "" && id !== undefined && id !== null) {
      requestPayload["clinic_id"] = id;
    }

    requestPayload["is_walkin"] = selectedSlotObj.is_walkin;
    let appointment_details = selectedProcedureList?.map(
      ({ appointment_slot_id, appointment_date, doctor_id, is_walkin }) => ({
        appointment_slot_id,
        appointment_date,
        doctor_id,
        is_walkin,
      })
    );
    requestPayload["order_id"] = orderId;
    requestPayload["follow_up_booking"] = followUpBooking;
    if (followUpBooking) {
      requestPayload["appointment_id"] = appointmentData?.appointment_id;
      requestPayload["source_lead_id"] = appointmentData?.id;
    }
    requestPayload["appointment_details"] = appointment_details;
    const bookingResponse = c2cPostApiHandler(
      BOOK_RESOURCE_APPOINTMENT,
      requestPayload
    );
    bookingResponse.then(([res, err]) => {
      if (!err && res.data.statusCode == 200) {
        // Add appointment id to the object
        let details = patientDetails;
        details.appointment_id = res.data.appointment_id;
        setPatientDetails(details);
      } else {
        C2CConsole.log("Error occurred");
      }
    });
  }

  const addBookingAPICall = () => {
    let slot = selectedSlot;
    let found = selectedProcedureList.find(
      (ob) => ob.id === selectedResourceProcedure.id
    );
    if (found && found?.custom_slot) {
      slot = found?.alloted_custom_slot?.slot_id;
    }
    let requestPayload = {
      patient_id: appointmentData?.patient_id,
      consultation_book_method:
        appointmentType == "online" ? "online-from-clinic" : appointmentType,
      appointment_date:
        selectedDate || moment(calenderDate).format("YYYY-MM-DD"),
      appointment_slot_id: slot,
      is_follow_up: followUpVal,
      registration_type: 0,
      doctor_id: selectedResourceProcedure?.doctor_id,
      patient_account_id: appointmentData?.patient_account_id,
      add_booking: true,
      order_id:
        !isAbhaTokenBooking && !followUpBooking && !isLeadBooking
          ? existingOrderId
          : orderId,
      follow_up_booking: followUpBooking,
      source_lead_id: followUpBooking ? appointmentData?.id : null,
      is_accept_terms: true,
    };
    if (followUpBooking) {
      requestPayload["appointment_id"] = appointmentData?.appointment_id;
    }
    if (found && found.custom_slot) {
      requestPayload["is_premium_slot"] = found.custom_slot;
      requestPayload["start_time"] = found["alloted_custom_slot"]["startTime"]
        ? moment(found["alloted_custom_slot"]["startTime"], "hh:mm A").format(
            "HH:mm:ssZ"
          )
        : "";
      requestPayload["end_time"] = found["alloted_custom_slot"]["endTime"]
        ? moment(found["alloted_custom_slot"]["endTime"], "hh:mm A").format(
            "HH:mm:ssZ"
          )
        : "";
    } else {
      requestPayload["is_premium_slot"] = false;
    }
    if (localStorage.getItem("user_type") === "staff") {
      requestPayload.staff_id = staffId;
    }
    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      requestPayload["clinic_id"] = clinicId;
    }
    requestPayload["is_walkin"] = selectedSlotObj.is_walkin;
    //  requestPayload
    if (selectedBookingType === "Laboratory") {
      bookResourceAppointmentAPICall(requestPayload);
    } else {
      let consultationSettingsId =
        hasResourceAccess || addBooking
          ? [0, 1, 5, 6].indexOf(selectedResourceProcedure?.id) > -1
            ? selectedResourceProcedure?.id
            : null
          : [0, 1, 5, 6].indexOf(apiSelectedConsultation?.value) > -1
          ? apiSelectedConsultation?.value
          : null;
      let procedureSettingsId =
        hasResourceAccess || addBooking
          ? [0, 1, 5, 6].indexOf(selectedResourceProcedure?.id) === -1
            ? selectedResourceProcedure?.id
            : null
          : [0, 1, 5, 6].indexOf(apiSelectedConsultation?.value) === -1
          ? apiSelectedConsultation?.value
          : null;
      requestPayload["procedure_settings_id"] = procedureSettingsId;
      requestPayload["consultation_settings_id"] = consultationSettingsId;

      bookAppointment(requestPayload);
    }
  };

  const bookResourceAppointmentAPICall = (requestPayload) => {
    setDisableSaveBtn(true);
    let appointment_details = [];
    let doctorIds = [];
    selectedProcedureList.forEach((data) => {
      if (!doctorIds?.includes(data?.doctor_id)) {
        doctorIds.push(data?.doctor_id);
      }
    });
    doctorIds.forEach((doctor_id) => {
      let filteredList = selectedProcedureList.filter(
        (data) => data?.doctor_id === doctor_id
      );
      if (selectedProcedureList?.length > 0) {
        if (filteredList[0].common_procedure) {
          let procIds = [];
          filteredList.forEach((data) => procIds.push(data?.id));
          let obj = {
            appointment_slot_id:
              hasResourceAccess || addBooking
                ? filteredList[0]?.custom_slot
                  ? filteredList[0]["alloted_custom_slot"]["slot_id"]
                  : filteredList[0].appointment_slot_id
                : allotedPremiumSlot?.slot_id,
            appointment_date:
              filteredList[0]?.appointment_date ||
              moment(calenderDate).format("YYYY-MM-DD"),
            doctor_id: filteredList[0]?.doctor_id,
            is_walkin: filteredList[0]?.is_walkin,
            common_procedure: true,
            procedure_ids: procIds,
            is_premium_slot: filteredList[0]?.custom_slot,
            start_time: filteredList[0]?.alloted_custom_slot?.startTime
              ? moment(
                  filteredList[0]?.alloted_custom_slot?.startTime,
                  "hh:mm A"
                ).format("HH:mm:ssZ")
              : null,
            end_time: filteredList[0]?.alloted_custom_slot?.endTime
              ? moment(
                  filteredList[0]?.alloted_custom_slot?.endTime,
                  "hh:mm A"
                ).format("HH:mm:ssZ")
              : null,
          };
          appointment_details.push(obj);
        } else {
          filteredList.forEach((item) => {
            let obj = {
              appointment_slot_id:
                hasResourceAccess || addBooking
                  ? item?.custom_slot
                    ? item?.alloted_custom_slot?.slot_id
                    : item?.appointment_slot_id
                  : item?.appointment_slot_id,
              appointment_date:
                item?.appointment_date ||
                moment(calenderDate).format("YYYY-MM-DD"),
              is_premium_slot: item?.custom_slot,
              doctor_id: item?.doctor_id,
              is_walkin: item?.is_walkin,
              common_procedure: false,
              procedure_ids: [item?.id],
              start_time: item?.alloted_custom_slot?.startTime
                ? moment(
                    item?.alloted_custom_slot?.startTime,
                    "hh:mm A"
                  ).format("HH:mm:ssZ")
                : null,
              end_time: item?.alloted_custom_slot?.endTime
                ? moment(item?.alloted_custom_slot?.endTime, "hh:mm A").format(
                    "HH:mm:ssZ"
                  )
                : null,
            };
            appointment_details.push(obj);
          });
        }
      }
    });

    let payload = {
      ...requestPayload,
      appointment_details: appointment_details,
      "authorizer-principal-id": {
        user_type: userType === "staff" ? "4" : "1",
        user_id: userType === "staff" ? staffId : userId,
        agent: "Web",
      },
    };
    const bookingResponse = c2cPostApiHandler(
      BOOK_RESOURCE_APPOINTMENT,
      payload
    );
    bookingResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        setDisableSaveBtn(false);
        const appointmentId = res?.data?.appointment_id;
        handelProcedureAppointmentId(appointmentId);
        // Add appointment id to the object
        let emptyObj = {};
        emptyObj.appointment_id = res.data.appointment_id;
        setAppointmentIDDetails(emptyObj);
        setState(3);
      } else {
        if (res.data.message) {
          swal({
            title: "Error",
            text: res.data.message,
            type: "error",
            icon: "error",
            button: "OK",
          });
        }
        C2CConsole.log("Error occurred");
        setDisableSaveBtn(false);
      }
    });
  };

  const bookAppointment = (requestPayload) => {
    const bookingResponse = c2cPostApiHandler(
      BOOK_DOCTOR_APPOINTMENT,
      requestPayload
    );
    bookingResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        const appointmentId = res?.data?.appointment_id;
        handelProcedureAppointmentId(appointmentId);
        // Add appointment id to the object
        let emptyObject = {};
        emptyObject.appointment_id = res.data.appointment_id;
        setAppointmentIDDetails(emptyObject);
        setState(3);
      } else {
        if (res.data.message) {
          swal({
            title: "Error",
            text: res.data.message,
            type: "error",
            icon: "error",
            button: "OK",
          });
        }
        C2CConsole.log("Error occurred");
      }
    });
  };

  const unblockAllSlots = () => {
    let slotArr = [];
    selectedProcedureList.forEach((data) => {
      if (
        data?.appointment_slot_id &&
        !slotArr.includes(data?.appointment_slot_id)
      ) {
        slotArr.push(data?.appointment_slot_id);
      }
    });
    if (slotArr?.length > 0) {
      unblockSlotsAPICall(slotArr);
    }
  };

  function prepareSavePatientPayload(patient_id) {
    let slot = selectedSlot;
    let found = selectedProcedureList.find(
      (ob) => ob.id === selectedResourceProcedure.id
    );
    if (found) {
      slot = found["alloted_custom_slot"]["slot_id"];
    }
    return {
      patient_id: patient_id,
      consultation_book_method: appointmentType,
      appointment_date: selectedDate,
      appointment_slot_id: slot,
      dob: patientDetails.dob,
      email: patientDetails.dob,
      gender: patientDetails.sex,
      is_follow_up: false,
      name: patientDetails.patientName,
      patient_address: patientDetails.address,
      patient_pincode: patientDetails.pincode,
      phone_number: patientDetails.mobileNumber,
      purpose_of_appointment: patientDetails.note,
      registration_type: 0, // TODO: pass correct value
      state_code: 29, // TODO: Pass correct value
      doctor_id: doctorData?.doctor_id ? doctorData?.doctor_id : userId,
      procedure_settings_id: "",
      consultation_settings_id: "",
    };
  }

  const handleFileState = (obj) => {
    setRetainFileState({ ...obj });
  };

  function getDoctorInfo() {
    if (
      (localStorage.getItem(LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION) &&
        localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID)) ||
      localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION)
    ) {
      return (
        <div className="d-flex pt-3 doct-info">
          {doctorData?.doctor_profile_picture_url?.length > 0 ? (
            <Image
              src={doctorData.doctor_profile_picture_url}
              roundedCircle
              className="profile-container"
            />
          ) : (
            <div className="profile-container no-image">
              {doctorData?.doctor_first_name
                ? doctorData?.doctor_first_name?.charAt(0)
                : doctorData?.dr_first_name
                ? doctorData?.dr_first_name?.charAt(0)
                : ""}
            </div>
          )}

          <div className="text-left px-3">
            <p className="doctor_name">{doctorData?.dr_name}</p>
            <p className="doctor_specialization">
              {doctorData?.specialization
                ? doctorData.specialization
                : "Specialization"}
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="d-flex pt-3 doct-info">
          {doctorData?.profile_picture_url?.length > 0 ? (
            <Image
              src={
                doctorData.profile_picture_url &&
                doctorProfileFiles + doctorData.profile_picture_url
              }
              roundedCircle
              className="profile-container"
            />
          ) : (
            <div className="profile-container no-image">
              {doctorData?.doctor_first_name
                ? doctorData?.doctor_first_name?.charAt(0)
                : doctorData?.dr_first_name
                ? doctorData?.dr_first_name?.charAt(0)
                : ""}
            </div>
          )}

          <div className="text-left px-3">
            <p className="doctor_name">{doctorData?.dr_name}</p>
            <p className="doctor_specialization">
              {doctorData?.specialization
                ? doctorData.specialization
                : "Specialization"}
            </p>
          </div>
        </div>
      );
    }
  }
  const getHeaderClassName = () => {
    if (
      ((hasResourceAccess || addBooking) && state > 1) ||
      (!hasResourceAccess && !addBooking) ||
      state > 1
    ) {
      return "book-appointment-header-titie-sec";
    } else {
      return "col-12 book-appointment-header-titie";
    }
  };

  const middleContent = () => {
    return (
      <>
        {(hasResourceAccess || addBooking) &&
          state === 1 &&
          window.innerWidth <= 768 && (
            <ResourceSelectionView
              resource={resource}
              resourceList={resourceList}
              selectedResource={selectedResource}
              procedureList={procedureList}
              searchProcedure={searchProcedure}
              selectedBookingType={selectedBookingType}
              addBooking={addBooking}
              handleSearchProcedure={handleSearchProcedure}
              handleResource={handleResource}
              handleProcedure={handleProcedure}
              onCloseModal={closeModal}
              handleBookingType={handleBookingType}
              handleProcedureList={handleProcedureList}
            />
          )}
      </>
    );
  };
  return (
    <>
      {props.openView ? (
        <>
          {openBookingModal ? (
            <Modal open={props.openView} onClose={closeModal}>
              <div className="physical-consult">
                <div className={modalBodyClassName}>
                  <div className="book-appointment-procedure-container">
                    <div className="book-appointment-procedure-wrapper">
                      <div className="col-lg-3 col-12 pr-lg-0 pt-lg-3 step-column step-desktop">
                        {localStorage.getItem("user_type") === "staff" &&
                          getDoctorInfo()}
                        <Steps state={state} setState={setState} />
                        <div className="future_appointment_container">
                          {state === 2 && patientAccountId && (
                            <FutureAppointmentsView
                              patientAccountId={patientAccountId}
                              doctorId={doctor?.doctor_id}
                            />
                          )}
                        </div>
                      </div>
                      <div className={containerClassName}>
                        <div className="sticky-top py-4 header_style  divider-b">
                          {" "}
                          <div className={getHeaderClassName()}>
                            {state !== 2 && <div>&nbsp;</div>}
                            {state === 2 && (
                              <img
                                alt=""
                                src={backArrow}
                                onClick={handleBackArrow}
                                className="physical-consultation-back-btn"
                              />
                            )}
                            <h1
                              className="ml-lg-4 font-weight-bold"
                              style={{ marginBottom: "0" }}
                            >
                              {modalHeader}
                            </h1>
                            {(((hasResourceAccess || addBooking) &&
                              state !== 1) ||
                              (!hasResourceAccess && !addBooking) ||
                              window.innerWidth < 768) && (
                              <div>
                                <button
                                  type="button"
                                  onClick={closeModal}
                                  className="btn-default btn-close"
                                >
                                  <span>
                                    <img
                                      className="close-img"
                                      src={closeIcon}
                                      alt="X"
                                    />
                                  </span>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3  pr-lg-0 pt-lg-3 step-column step-mobile">
                          {localStorage.getItem("user_type") === "staff"
                            ? getDoctorInfo()
                            : null}
                          <Steps state={state} setState={setState} />
                        </div>
                        {state === 2 &&
                          patientAccountId &&
                          window.innerWidth < 768 && (
                            <FutureAppointmentsView
                              patientAccountId={patientAccountId}
                              doctorId={doctor?.doctor_id}
                            />
                          )}

                        <div
                          className={`${
                            state === 2
                              ? ""
                              : state === 1
                              ? "appointment-steps-wrapper"
                              : "appointment-steps-wrapper-sec"
                          }`}
                        >
                          <div>{getViewState(state)}</div>
                        </div>
                      </div>
                      {(hasResourceAccess || addBooking) &&
                        state === 1 &&
                        window.innerWidth > 768 && (
                          <div className="resource-modal-contanier">
                            <div>
                              <button
                                type="button"
                                className="btn-default btn-close-resource"
                                onClick={closeModal}
                              >
                                <span>
                                  <img
                                    className="close-img"
                                    src={closeIcon}
                                    alt="X"
                                  />
                                </span>
                              </button>
                            </div>
                            <ResourceSelectionView
                              resource={resource}
                              resourceList={resourceList}
                              selectedResource={selectedResource}
                              procedureList={procedureList}
                              searchProcedure={searchProcedure}
                              selectedBookingType={selectedBookingType}
                              addBooking={addBooking}
                              handleSearchProcedure={handleSearchProcedure}
                              handleResource={handleResource}
                              handleProcedure={handleProcedure}
                              onCloseModal={closeModal}
                              handleBookingType={handleBookingType}
                              handleProcedureList={handleProcedureList}
                            />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          ) : openCancelPopup ? (
            <C2CMiddlePopup
              openPopup={openCancelPopup}
              dialogClassName="cancel-slots-popup"
              title={
                <span style={{ fontSize: "20px" }}>
                  Closing this window will release the allocated slots. Are you
                  sure to continue?
                </span>
              }
              titleImg={warningImg}
              leftBtn="Yes"
              rightBtn="No"
              handleLeftBtnClick={handleConfirmClose}
              handleRightBtnClick={() => {
                setOpenCancelPopup(false);
                setOpenBookingModal(true);
              }}
              handleClosePopup={() => {
                setOpenCancelPopup(false);
                setOpenBookingModal(true);
              }}
            />
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default PhysicalConsultationModal;
